import * as Modal from '#/components/shared/Modal';

import {
  useUsernameEditModalActions,
  useUsernameEditModalView,
} from '#/features/account/username-edit-modal-context';
import { UsernameFormProvider } from '#/features/account/username-form-context';
import { useTranslation } from '#/features/localization/utils';

import { Result } from '#/utils/types';

import * as UsernameForm from './UsernameForm';

export default function UsernameEditModal() {
  const modalView = useUsernameEditModalView();
  const modalActions = useUsernameEditModalActions();
  const { t } = useTranslation();

  const handleDismiss = () => {
    modalActions.close();
  };

  const handleSubmitComplete = (result: Result<void>) => {
    if (!result.ok) return;
    modalActions.close();
  };

  if (!modalView.isOpen) return;

  return (
    <Modal.Root
      isOpen
      onDismiss={handleDismiss}
      aria-labelledby="username-edit-modal"
    >
      <Modal.Header>
        <Modal.Title id="username-edit-modal">
          {t('Edit Your Username')}
        </Modal.Title>
        <Modal.CloseButton onClick={handleDismiss} />
      </Modal.Header>

      <Modal.Paragraph>
        {t(
          'Your username will be visible to other users unless you choose to hide it. You can always change it later.',
        )}
      </Modal.Paragraph>

      <UsernameFormProvider>
        <UsernameForm.Form onSubmitComplete={handleSubmitComplete}>
          <UsernameForm.Fields />
          <UsernameForm.Actions>
            <UsernameForm.Submit />
          </UsernameForm.Actions>
        </UsernameForm.Form>
      </UsernameFormProvider>
    </Modal.Root>
  );
}
